import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { UnsavedChangesService } from '../../unsaved-changes.service';

export interface CanComponentDeactivate {
  canDeactivate: () => boolean;
}

@Injectable({
  providedIn: 'root',
})
export class UnsavedChangesGuard implements CanDeactivate<CanComponentDeactivate> {
  constructor(private unsavedChangesService: UnsavedChangesService) {}

  canDeactivate(component: CanComponentDeactivate): boolean {
    if (this.unsavedChangesService.hasUnsaved) {
      return component.canDeactivate ? component.canDeactivate() : true;
    }
    return true;
  }
}
